import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import React, { useEffect, useState } from 'react';
import { useGetList } from 'react-admin';
import { ChartComponentProps } from '@ugo/models';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

const TotalServicesBooked = (props: ChartComponentProps) => {
  const [sum, setSum] = useState<number>(0);

  const { data, loading } = useGetList(
    'reservation',
    { page: 1, perPage: 999999 },
    { field: 'created_at', order: 'DESC' },
    {
      'created_at@_gte': props.startDate,
      'created_at@_lte': props.endDate,
      'is_manual@_eq': props.shouldIncludeManualB2cReservations,
    }
  );

  useEffect(() => {
    setSum(Object.keys(data as any).length);
  }, [data]);
  return (
    <Card>
      <Box p={2}>
        {loading ? (
          <Box display="flex" justifyContent="center">
            <CircularProgress color="primary" />
          </Box>
        ) : (
          <>
            <Typography align="center" variant="h6">
              Services booked
            </Typography>
            <Typography align="center" color="primary" variant="h5">
              <b>{sum}</b>
            </Typography>
          </>
        )}
      </Box>
    </Card>
  );
};

export default TotalServicesBooked;
